import { CurdDataSetConfig, FormFieldType } from '../types';
import { Profile } from '../types/profile';
import { ChoiceTypes } from '@mri/enums';

const filterConfigs =  [
  {
    key: 'name',
    label: 'Nombre',
    type: FormFieldType.STRING
  },
  {
    key: 'type',
    label: 'Tipo',
    type: FormFieldType.OPTIONS_MULTIPLE,
    optionsConfigKey: ChoiceTypes.PROFILE_TYPE
  },
  {
    key: 'permissions',
    label: 'Permisos',
    type: FormFieldType.OPTIONS_MULTIPLE,
    containerClass: 'col-12',
    optionsConfigKey: ChoiceTypes.PERMISSION
  }

];

export const profilesDataSetConfig: CurdDataSetConfig<Profile> = {
  entityName: 'Perfil',
  collectionName: 'Profiles',
  gatewayUrl: 'profiles',
  baseBreadcrumb: 'profiles',
  form: {
    listRedirectUrl: 'console/profiles/list',
    fields: [
      {
        key: 'name',
        label: 'Nombre',
        type: FormFieldType.STRING,
        containerClass: 'col-12'
      },
      {
        key: 'description',
        label: 'Descripcion',
        type: FormFieldType.STRING,
        containerClass: 'col-12'
      },
      {
        key: 'type',
        label: 'Tipo',
        type: FormFieldType.OPTIONS,
        containerClass: 'col-12',
        optionsConfigKey: ChoiceTypes.PROFILE_TYPE
      },
      {
        key: 'permissionsData',
        label: 'Permisos',
        type: FormFieldType.OPTIONS_MULTIPLE,
        containerClass: 'col-12',
        optionsGateway: 'config/permissions',
        fillValue: (element: Profile) => (element?.permissions || []).map(p => p.key)
      }
    ],
    handleObject: data => {
      const { permissionsData, ...restData } = data;
      const profileData = restData as unknown as Profile;
      const permissions = (Array.isArray(permissionsData) ? permissionsData : [permissionsData]).map(key => ({ key }));

      return {
        ...profileData,
        permissions
      };
    }
  },
  list: {
    pageConfig: {
      title: 'Lista de perfiles y licencias',
      breadcrumb: [
        {
          title: 'Perfiles',
          type: 'item',
          link: '/console/profiles/list'
        },
        {
          title: 'Lista',
          type: 'item',
          link: '/console/profiles/list',
          pageName: 'Perfiles y licencias'
        }
      ]
    },
    filter: filterConfigs,
    searchFilter: filterConfigs,
    table: {
      columns: [
        { key: 'name', label: 'Nombre' },
        { key: 'description', label: 'Descripcion' },
        { key: 'type', label: 'Tipo' },
        {
          key: 'permissions', label: 'Permisos', getValue: ({ element }) => {
            const permissions = element.permissions || [];
            if (permissions.length === 0) return 'No tiene permisos';

            const [p1, p2, ...restP] = permissions;
            return [p1, p2]
              .filter(p => !!p)
              .map(p => `<span class="badge">${p?.key}</span>`)
              .join('') + (restP.length > 0 ? `<span class="badge">${restP.length}+</span>` : '');
          }
        }
      ]
    },
    actionsKeys: ['create', 'edit', 'delete']
  },
  pages: ['list', 'create', 'edit']
};
